import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

export const PageShell = ({ eyebrow, title, children, testId }) => (
  <main data-testid={testId}>
    <SiteHeader />
    <section className="grain relative bg-gray-900 pb-16 pt-36">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <p className="text-xs font-semibold uppercase tracking-widest text-emerald-300">{eyebrow}</p>
        <h1 className="mt-3 font-display text-4xl font-bold tracking-tight text-white sm:text-5xl">{title}</h1>
      </div>
    </section>
    <section className="min-h-[50vh] bg-slate-50 py-14">
      <div className="mx-auto max-w-6xl px-6 md:px-10">{children}</div>
    </section>
    <SiteFooter />
  </main>
);
